import clsx from 'clsx';
import React from 'react';

export type WrapperSize = 'default' | 'sm';

interface WrapperProps {
  size?: WrapperSize;
  children: React.ReactNode;
  marginTop?: number;
  marginBottom?: number;
}

const Wrapper: React.FC<WrapperProps> = ({ children, size = 'default', marginTop, marginBottom }) => {
  return (
    <div
      className={clsx(
        'mx-4 md:mx-8 lg:mx-auto lg:max-w-[970px]',
        size === 'default' && 'xl:max-w-[1140px]',
        size === 'sm' && 'xl:max-w-[975px]',
        marginTop !== undefined && `mt-${marginTop}`,
        marginBottom !== undefined && `mb-${marginBottom}`
      )}
    >
      {children}
    </div>
  );
};

export default Wrapper;
